import React from 'react'
import PropTypes from 'prop-types'
import AccountManagementButton from './AccountManagementButton'

/**
 * A react component that controls when to display the Add Domain functionality
 */
const AccountManagementControl = (props) => (
    props.visible
        ?
        <div className="AccountManagementControl">
            {React.Children.map(props.children, (child) => React.cloneElement(child, {click: props.click}))}
        </div>
        :
        null
)

AccountManagementControl.propTypes = {
    visible: PropTypes.bool.isRequired,
    click: PropTypes.func.isRequired,
    children: PropTypes.element.isRequired
}

AccountManagementControl.defaultProps = {
    children: <AccountManagementButton text='Account'/>
}

export default AccountManagementControl


// WEBPACK FOOTER //
// ./src/components/AccountManagementControl/AccountManagementControl.js